import { ComponentBase } from '../../../component-base';
import { IMouseMove, IMouseRelease, IDoubleClick } from '../Interfaces';
import { Injectable } from '@angular/core';
import { SelectableLine } from '../object3D/SelectableLine';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { PolyLine, Line, ConnectionPoint } from '../object3D';
import { SelectComponent } from './SelectComponent';
declare let THREE: any;

@Injectable()
export class DrawLineComponent extends ComponentBase implements IMouseMove, IMouseRelease, IDoubleClick {
  dblclick(e: MouseEvent) {
    
    this.firstPoint = null;
    this.drawings.canvas.remove(this.line);
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }

  private firstPoint = null;
  private line: PolyLine;
  currentLine: any;
  currentPoint: any;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
  }

  private snapPointToSaveNeededAngle(point) {
    const lineLength = this.firstPoint.distanceTo(point);
    let finalPoint = this.firstPoint.clone();
    for (let i = 0; i < 24; i++) {
      const angle = Math.PI / 12 * i;
      const pPoint = new THREE.Vector3(Math.cos(angle), 0, Math.sin(angle));
      pPoint.setLength(lineLength);
      pPoint.add(this.firstPoint);
      if (point.distanceTo(pPoint) < point.distanceTo(finalPoint)) {
        finalPoint = pPoint;
      }
    }
    return finalPoint;
  }

  mouseUp(e: MouseEvent) {
    if (!this.firstPoint) {
      this.firstPoint = this.positionCalculator.calculate(e);
      var pos = this.firstPoint.clone();
      this.line = new PolyLine();
      this.line.position.copy(pos);
      this.drawings.canvas.add(this.line);
      this.line.updateMatrixWorld();
      this.line.worldToLocal(pos).setY(0);
      this.currentLine = new Line();
      this.currentLine.position.copy(pos);
      this.line.add(this.currentLine);
      const connectionPoint = new ConnectionPoint(undefined, this.currentLine.id);
      connectionPoint.position.copy(pos);
      this.line.add(connectionPoint);
    } else {
      const prevLineId = this.currentLine ? this.currentLine.id : undefined;
      this.line.updateMatrixWorld();
      this.line.worldToLocal(this.currentPoint).setY(0);
      const connectionPoint = new ConnectionPoint(prevLineId, undefined);
      connectionPoint.position.copy(this.currentPoint);
      this.line.add(connectionPoint);
      this.firstPoint = null;
    }
    return true;
  }

  mouseMove(e: MouseEvent) {
    if (this.firstPoint) {
      let position = this.positionCalculator.calculate(e);
      const currentAngle = Math.atan((position.z - this.firstPoint.z) / (position.x - this.firstPoint.x));

      if (!e.shiftKey && (currentAngle % Math.PI / 12 !== 0)) {
        position = this.snapPointToSaveNeededAngle(position);
      }
      this.line.updateMatrixWorld();
      var pos = position.clone();
      this.line.worldToLocal(pos);
      
      this.currentLine.update(this.currentLine.position, pos.setY(0));
      this.currentPoint = position;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawLineComponent.ts